import styles from './DirectoryButton.module.scss';
import React, { useContext, useEffect, FunctionComponent } from 'react';
import { DirectoryListType } from '../../directory-list/DirectoryList';
import { AppContext } from '../../../context/AppContext';
import { defaultAppState } from '../../../context/DefaultAppState';

export interface IDirectoryButtonProps {
  buttonText: string;
  buttonIndex: number;
  currentListType: DirectoryListType;
  listType: DirectoryListType;
}

const DirectoryButton: FunctionComponent<IDirectoryButtonProps> = ({ buttonText, buttonIndex, currentListType, listType, children }) => {
  const appContext = useContext(AppContext);
  useEffect(() => {
    if (currentListType === listType) {
      appContext.updateListType(listType);
    }
  });
  return (
    <>
      <button
        className={`${styles.directoryButton}${appContext.isDirectorySelected && currentListType === listType ? ' ' + styles.isActive : ''}`}
        onClick={() => {
          appContext.updateListType(listType);
          appContext.updateSelected(true);
          //Reverts SearchBarSpecialtySelect to 'All Specialties' when clicking
          appContext.updateChosenSpecialty(defaultAppState.chosenSpecialty);
        }}
      >
        <span className={`${styles.icon} ${styles.baseline}`}>{children}</span>
        <span>{buttonText}</span>
      </button>
    </>
  );
};

export default DirectoryButton;
